import React from 'react';
import { useHistory } from 'react-router-dom';
import Logo from 'components/Common/Logo';
import ClickableDiv from 'components/Common/ClickableDiv';
import NavBar from 'components/Common/NavBar';

import Styles from './index.module.css';

function AppBar() {
  const history = useHistory();
  return (
    <div
      className={Styles.container}
    >
      <div
        className={Styles.leftPart}
      >
        <Logo />
      </div>
      <div
        className={Styles.midPart}
      >
        <NavBar />
      </div>
      <div
        className={Styles.rightPart}
      >
        <ClickableDiv style={{ color: '#455780' }} onClick={() => { history.push('/Register'); }}>登出</ClickableDiv>
      </div>
    </div>
  );
}

export default AppBar;
